import Substore from "../Substore";

export default class DayModalStore extends Substore {
  day = 0;
  month = 0;
}
